export default __webpack_public_path__ + "static/media/left-sign-dir.fd80689b.png";